import React from 'react';

import api, { urlParamCharacter } from '../services/api';
import Thumbnail from '../components/Thumbnail';
import FetcherButton from '../components/FetcherButton';

const NUM_WORKS = 10;

export default class WorksPage extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      works: Array.from(Array(NUM_WORKS).keys()),
      previousPage: 0,
      totalPages: 1,
      isLoading: true,
    };
    this.getWorks = this.getWorks.bind(this);
  }

  componentDidMount() {
    this.getWorks();
  }

  getWorks(page = 1) {
    const { previousPage } = this.state;

    this.setState({ isLoading: true });

    api.get(`/works${urlParamCharacter}per_page=${NUM_WORKS}&page=${page}&orderby=menu_order&order=asc`)
      .then((response) => {
        if (page > 1) {
          this.setState((prevState) => ({
            works: [...prevState.works, ...response.data],
          }));
        } else {
          this.setState({ works: response.data });
        }

        this.setState({
          previousPage: previousPage + 1,
          totalPages: parseInt(response.headers['x-wp-totalpages'], 10),
          isLoading: false,
        });
      })
      .catch((error) => {
        if (process.env.NODE_ENV === 'development') {
          // eslint-disable-next-line no-console
          console.error(error);
        }
      });
  }

  render() {
    const {
      works,
      previousPage,
      totalPages,
      isLoading,
    } = this.state;

    return (
      <div className="container">
        <h1 className="sr-only">Films and Photos</h1>
        <div className="columns">
          {works.map((work, i) => (
            <Thumbnail
              key={work.slug || i}
              slug={work.slug}
              title={work.title && work.title.rendered}
              imageUrl={work.acf && work.acf.image.url}
              imageAlt={work.acf && work.acf.image.alt}
              firstCreditRole={work.acf && work.acf.first_credit.role}
              firstCreditPersonOrCompany={work.acf && work.acf.first_credit.person_or_company}
              secondCreditRole={work.acf && work.acf.second_credit.role}
              secondCreditPersonOrCompany={work.acf && work.acf.second_credit.person_or_company}
              thirdCreditRole={work.acf && work.acf.third_credit.role}
              thirdCreditPersonOrCompany={work.acf && work.acf.third_credit.person_or_company}
              isLoading={isLoading}
            />
          ))}
        </div>
        <FetcherButton
          isLoading={isLoading}
          previousPage={previousPage}
          totalPages={totalPages}
          getItems={this.getWorks}
          text="More films & photos"
        />
      </div>
    );
  }
}
